import BaseError from '../BaseError';

class ComponentNotFoundError extends BaseError {
  constructor(componentName) {
    super(`${componentName || 'Component'} doesn't exist.`);
  }
}

export default ComponentNotFoundError;
